import { IntegrationsService } from './integrations.service';
import { IntegrationChannel } from './integration.type';
import {SnackBarService} from "@teammood/shared/ui/snack-bar";
import {Component, Inject, OnInit, ChangeDetectionStrategy} from "@angular/core";
import {LoggerService} from "@teammood/shared/util/logger";
import {WINDOW} from "@teammood/shared/util/core";

@Component({
    selector: "integrations",
    templateUrl: "./integrations.component.html",
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class IntegrationsComponent implements OnInit {

    email: IntegrationChannel;
    slack: IntegrationChannel;
    msteams: IntegrationChannel;
    webex: IntegrationChannel;

    constructor(
        private logger: LoggerService,
        @Inject(WINDOW) private window: Window,
        private integrationsService: IntegrationsService, 
        private snackBarService: SnackBarService
        ){}

    ngOnInit() {
        return this.load();
    }

    private async test(name: string) {
        try {
            await this.integrationsService.test(name);
            this.snackBarService.success('Ok');
        } catch (error) {
            this.logger.error(name + " test error", error);
        }
    }

    onTest(name: string){
        return this.test(name);
    }

    private async toggle(name: string) {
        try {
            await this.integrationsService.toggle(name);
            this.snackBarService.success('Ok');
            await this.load();
        } catch (error) {
            this.logger.error(name + " toggle error", error);
        }
    }

    onToggle(name: string){
        return this.toggle(name);
    }

    private async remove(name: string) {
        try {
            await this.integrationsService.remove(name);
            this.snackBarService.success('Ok');
            await this.load();
        } catch (error) {
            this.logger.error(name + " remove error", error);
        }
    }

    onRemove(name: string){
        return this.remove(name);
    }

    private async invite(name: string) {
        try {
            await this.integrationsService.invite(name);
            this.snackBarService.success('Invitation sent');
        } catch (error) {
            this.logger.error(name + " test error", error);
        }
    }

    private async load() {
        try {
            const result = await this.integrationsService.integrations();

            this.email = result.email;
            this.slack = result.slack;
            this.msteams = result.msteams;
            this.webex = result.webex;

            if (result.slack.config) {
                this.slack.onconfig = () => {
                    this.window.location.href = result.slack.config;
                };
            }

            if (result.msteams.install) {
                this.msteams.onconfig = () => {
                    this.window.location.href = result.msteams.install;
                };
            }

            if (result.webex && result.webex.install) {
                this.webex.onconfig = () => {
                    this.invite(result.webex.name);
                    this.window.location.href = result.webex.install;
                }
            }

        } catch (error) {
            this.logger.error("integrations loading error", error);
            if (error.status === 403) {
                alert('Well tried, but you are not authorized or you have to upgrade to the Premium plan');
            }
        }
    }
}